import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AssessmentCompletionTemplate from '../components/AssessmentCompletionTemplate';
import { createPhysicalWellnessLearnAssessmentConfig } from '../config/assessmentCompletionConfigs';

interface PhysicalWellnessAssessmentResult {
  id: string;
  assessmentType: 'physical';
  scores: {
    overall: number;
    subscales?: {
      cardiovascular?: number;
      metabolic?: number;
      musculoskeletal?: number;
      respiratory?: number;
      neurological?: number;
    };
  };
  results: {
    level: 'Low' | 'Moderate' | 'High';
    interpretation: string;
  };
  createdAt: string;
  // Also support nested structure for compatibility
  assessmentData?: {
    scores: {
      overall: number;
      subscales?: {
        cardiovascular?: number;
        metabolic?: number;
        musculoskeletal?: number;
        respiratory?: number;
        neurological?: number;
      };
    };
    results: {
      level: 'Low' | 'Moderate' | 'High';
      interpretation: string;
    };
  };
}

const PhysicalWellnessLearnAssessmentCompletionPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Get the assessment result from navigation state
  const assessmentResult = location.state?.assessmentResult as PhysicalWellnessAssessmentResult;

  // Handle navigation in useEffect to avoid calling navigate during render
  useEffect(() => {
    if (!assessmentResult) {
      // If no result data, redirect to learn page
      navigate('/panel/learn/');
      return;
    }
  }, [assessmentResult, navigate]);

  // Don't render anything if no assessment result
  if (!assessmentResult) {
    return null;
  }

  // Create configuration using the template system
  const config = createPhysicalWellnessLearnAssessmentConfig(assessmentResult);

  // Use the template component
  return <AssessmentCompletionTemplate config={config} />;
};

export default PhysicalWellnessLearnAssessmentCompletionPage;


